import { useLocation } from "react-router-dom";
import { Fragment } from "react/jsx-runtime"
import { DashboardHeader } from "../components/top-bar/Dashboard-header";
import { Card, Col, Row } from "antd";

export const RegistrationAnalysisstepPerMonthView = () => {
    const location = useLocation();
    const pathnameWithoutDashboard = location.pathname.replace('/dashboard/', '');

    return (
        <Fragment>
            <DashboardHeader title={pathnameWithoutDashboard} />
            <Row>
                <Col span={6}>
                    <div className="sales_regis">
                        <Card>
                            <img src="" alt="" />
                            <p>Total Participants - Registration</p>
                            <h2>KWD 140000</h2>
                        </Card>
                    </div>
                </Col>
            </Row>
            {/* <Row>
                <Col span={24}>
                    <RegistrationAnalysisstepPerMonth />
                </Col>
                <Col span={6}>
                    <RegistrationbookedtypeView />
                </Col>
                 <Col span={6}>
                    <RegistrationChannelView />
                </Col>
                   <Col span={6}>
                    <RegistrationAbandonmentView />
                </Col>
                <Col span={6}>
                    <RepeatParticipationView />
                </Col>
               
            </Row> */}
        </Fragment>
    )
}